"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractCommand = void 0;
const providers_1 = require("../providers");
const facebook_client_1 = require("../facebook/facebook.client");
const google_client_1 = require("../google/google.client");
const cdp_client_1 = require("../cdp/cdp.client");
class AbstractCommand {
    constructor(input) { }
    getCommandService(config) {
        switch (config.eventTarget) {
            case providers_1.TrackingTargetProviderEnum.FACEBOOK_PIXEL:
                return new facebook_client_1.FacebookCommands(config);
            case providers_1.TrackingTargetProviderEnum.GOOGLE_ANALYTICS:
                return new google_client_1.GoogleCommands(config);
            case providers_1.TrackingTargetProviderEnum.CDP:
                return new cdp_client_1.CdpCommands(config);
            case providers_1.TrackingTargetProviderEnum.FACEBOOK_CONVERSION:
                return new facebook_client_1.FacebookCommands(config);
            default:
                throw new Error(config.eventTarget + ' is not supported');
        }
    }
}
exports.AbstractCommand = AbstractCommand;
